import React, { useState } from 'react';
import { colors, spacing, shadows } from '../../design/tokens';
import { theme } from '../../design/theme';
import { useAuth } from '../../context/AuthContext';

export const CheckoutPage: React.FC = () => {
  const { user } = useAuth();
  const [quantity, setQuantity] = useState(5);
  const itemPrice = 1.00;
  const taxRate = 0.18;

  const total = itemPrice * quantity;
  const tax = total * taxRate;
  const grandTotal = total + tax;

  return (
    <div style={{ 
      padding: spacing.xxl, 
      backgroundColor: colors.neutral[50], 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <div style={{ maxWidth: '1000px', width: '100%' }}>
        <h1 style={{ fontSize: '32px', fontWeight: 700, marginBottom: spacing.xl, textAlign: 'left' }}>
          eStore Order Checkout <span style={{ fontWeight: 400, fontSize: '18px', color: colors.brand.main }}>or request quote</span>
        </h1>

        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '8px', 
          boxShadow: shadows.sm, 
          padding: spacing.xl,
          border: `1px solid ${colors.neutral[200]}`,
          marginBottom: spacing.xl
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: `1px solid ${colors.neutral[200]}`, textAlign: 'left', color: colors.neutral[500], fontSize: '12px' }}>
                <th style={{ paddingBottom: spacing.sm }}>Product</th>
                <th style={{ paddingBottom: spacing.sm }}>Order / PO Number</th>
                <th style={{ paddingBottom: spacing.sm }}>Item Price</th>
                <th style={{ paddingBottom: spacing.sm }}>Quantity</th>
                <th style={{ paddingBottom: spacing.sm, textAlign: 'right' }}>Extended Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ paddingTop: spacing.xl, width: '40%' }}>
                  <div style={{ fontWeight: 600, color: colors.neutral[500], fontSize: '12px' }}>SKU:EXI-CREDITS</div>
                  <div style={{ fontWeight: 700, fontSize: '16px', margin: `${spacing.xs} 0` }}>Exibrain AI Credits</div>
                  <div style={{ fontSize: '13px', color: colors.neutral[600], lineHeight: 1.4 }}>
                    An AI-powered coding companion for engineering teams.<br />
                    Valid for one year from purchase date.
                  </div>
                </td>
                <td style={{ paddingTop: spacing.xl }}>—</td>
                <td style={{ paddingTop: spacing.xl }}>US ${itemPrice.toFixed(2)}</td>
                <td style={{ paddingTop: spacing.xl }}>
                  <input 
                    type="number" 
                    value={quantity} 
                    onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 0))}
                    style={{ 
                      width: '60px', 
                      padding: '8px', 
                      border: `1px solid ${colors.neutral[300]}`,
                      borderRadius: '4px',
                      textAlign: 'center'
                    }} 
                  />
                </td>
                <td style={{ paddingTop: spacing.xl, textAlign: 'right', fontWeight: 600 }}>
                  US ${total.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td colSpan={5} style={{ padding: `${spacing.xl} 0` }}>
                  <a href="#" style={{ color: colors.brand.main, textDecoration: 'none', fontSize: '14px' }}>Have a discount code?</a>
                </td>
              </tr>
            </tbody>
          </table>

          <div style={{ borderTop: `1px solid ${colors.neutral[200]}`, paddingTop: spacing.xl, display: 'flex', justifyContent: 'flex-end' }}>
            <div style={{ width: '300px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: spacing.sm, color: colors.neutral[600] }}>
                <span>Total</span>
                <span>US ${total.toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: spacing.sm, color: colors.healthy.main }}>
                <span>TAX (18%)</span>
                <span>✔ US ${tax.toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '20px', fontWeight: 700, marginTop: spacing.md }}>
                <span>Grand Total</span>
                <span>US ${grandTotal.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '8px', 
          boxShadow: shadows.sm, 
          padding: spacing.xl,
          border: `1px solid ${colors.neutral[200]}`
        }}>
          <h3 style={{ fontSize: '18px', fontWeight: 700, marginBottom: spacing.xl }}>Licensee information</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: spacing.xl, alignItems: 'center', marginBottom: spacing.lg }}>
            <div style={{ color: colors.neutral[600], fontSize: '14px' }}>Profile ID: {user?.id || '24733913'}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr', gap: spacing.md, alignItems: 'center' }}>
                <label style={{ fontSize: '14px' }}>Street address</label>
                <input type="text" style={{ padding: '10px', border: `1px solid ${colors.neutral[300]}`, borderRadius: '4px' }} defaultValue="Bhommatha Thalluri Heights" />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: spacing.xl, alignItems: 'center', marginBottom: spacing.lg }}>
            <div></div>
            <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr', gap: spacing.md, alignItems: 'center' }}>
                <label style={{ fontSize: '14px' }}>City</label>
                <input type="text" style={{ padding: '10px', border: `1px solid ${colors.neutral[300]}`, borderRadius: '4px' }} defaultValue="Kankipadu" />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: spacing.xl, alignItems: 'center', marginBottom: spacing.lg }}>
            <div></div>
            <div style={{ display: 'grid', gridTemplateColumns: '100px 1fr', gap: spacing.md, alignItems: 'center' }}>
                <label style={{ fontSize: '14px' }}>State</label>
                <select style={{ padding: '10px', border: `1px solid ${colors.neutral[300]}`, borderRadius: '4px' }}>
                    <option>Andhra Pradesh</option>
                </select>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: spacing.xxl }}>
            <button style={{ 
              backgroundColor: colors.brand.main, 
              color: 'white', 
              padding: `${spacing.md} ${spacing.xxl}`, 
              border: 'none', 
              borderRadius: '6px', 
              fontWeight: 700, 
              fontSize: '16px',
              cursor: 'pointer'
            }}>
              Proceed to Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
